import React, { useState } from "react";
import { Link, useNavigate } from "react-router-dom";
import InputField from "../../../../components/Common/InputField";
import { Box, Button, FormControl, InputLabel, MenuItem, Select, styled } from "@mui/material";
import { useForgotPasswordMutation } from "../../../../services/authService";
import { useFetchOrganizationsQuery } from "../../../../services/profileService";
import { toast, ToastContainer } from "react-toastify";

const ForgotPasswordForm = () => {
  const [email, setEmail] = useState("");
  const [loading, setLoading] = useState(false);
  const [error, setError] = useState("");
  
  const navigate = useNavigate();
  const { data: organizations, isLoading: orgLoading } = useFetchOrganizationsQuery();
  const [selectedOrgId, setSelectedOrgId] = useState("");

  const [forgotPassword] =
    useForgotPasswordMutation();

  const handleSubmit = async (e) => {
    e.preventDefault();
    setLoading(true);
    try {
      
      const resp = await forgotPassword({ email,organization_id: selectedOrgId });

      if (resp?.error) {
        console.log(resp?.error);
        
        setError(resp?.error?.message, { message: "Failed to send reset email." }, { shouldFocus: true });
        return false;
      }
      console.log(resp.data);
     
      toast.success("Forgot password request sent successfully!");
      // navigate("/verify-code");
      navigate("/verify-code", {
        state: { email, organization_id: selectedOrgId }, // Pass selected organization ID
      });
    } catch (err) {
      console.error("Forgot password error:", err);
    }
    finally {
      setLoading(false); // Stop the loading state once the request is done
    }
   

  };

  return (
    <>
      <form onSubmit={handleSubmit}>
        <FormMiddleBoxWrap>
          <RowWrap>
            <Col12Wrap>
            <ToastContainer />
              <Box sx={{ maxWidth: "400px", margin: "auto" }}>
              <FormGroupWrap>
                  <FormControl fullWidth>
                    <InputLabel id="organization-select-label">
                      Organization
                    </InputLabel>
                    <Select
                      labelId="organization-select-label"
                      id="organization-select"
                      value={selectedOrgId}
                      onChange={(e) => setSelectedOrgId(e.target.value)}
                      disabled={orgLoading}
                    >
                      {organizations?.data?.map((org) => (
                        <MenuItem key={org.id} value={org.id}>
                          {org.name}
                        </MenuItem>
                      ))}
                    </Select>
                  </FormControl>
                </FormGroupWrap>

                <FormGroupWrap>
                  <InputField
                    type="email"
                    name="email"
                    placeholder="Enter your email"
                    value={email}
                    onChange={(e)=> setEmail(e.target.value)}
                    register={()=>{}}
                    errorMessage={error}
                  />
                </FormGroupWrap>
                <FormGroupWrap>
                  <CustomBtn
                    type="submit"
                    variant="outlined"
                    disabled={loading}
                  >
                    {loading ? "Sending..." : "Send Reset Link"}
                  </CustomBtn>
                </FormGroupWrap>
                <FormGroupWrap sx={{ marginBottom: "0", textAlign: 'center' }}>
                    <CustomLink to="/">Sign in</CustomLink>
                </FormGroupWrap>
              </Box>
            </Col12Wrap>
          </RowWrap>
        </FormMiddleBoxWrap>
      </form>

      {/* <div>
        <h2>Forgot Password</h2>
        <form onSubmit={handleSubmit}>
          <InputField
            type="email"
            name="email"
            placeholder="Enter your email"
            register={() => {}}
            errorMessage={error}
          />

          <button type="submit" disabled={loading}>
            {loading ? "Sending..." : "Send Reset Link"}
          </button>
        </form>
      </div> */}
    </>
  );
};

export default ForgotPasswordForm;

const FormMiddleBoxWrap = styled(Box)(() => ({
  padding: "50px 150px",
  background: "#ffffff",
  borderRadius: "0px 0px 7px 7px",
  maxWidth: "1030px",
  marginLeft: "auto",
  marginRight: "auto",
  marginBottom: "16px",
  boxShadow: "0 0 5px 0 rgba(0, 0, 0, 0.05)",
  "@media (max-width: 1199px)": {
    maxWidth: "100%",
    paddingLeft: "100px",
    paddingRight: "100px",
  },
  "@media (max-width: 991px)": {
    paddingLeft: "50px",
    paddingRight: "50px",
  },
  "@media (max-width: 575px)": {
    paddingLeft: "15px",
    paddingRight: "15px",
  },
}));
const RowWrap = styled(Box)(() => ({
  display: "flex",
  flexWrap: "wrap",
  marginLeft: "-15px",
  marginRight: "-15px",
}));
const Col12Wrap = styled(Box)(() => ({
  flex: "0 0 auto",
  width: "100%",
  maxWidth: "100%",
  paddingLeft: "15px",
  paddingRight: "15px",
}));
const FormGroupWrap = styled(Box)(() => ({
  marginBottom: "20px",
  position: "relative",
}));
const CustomBtn = styled(Button)(() => ({
  width: "100%",
  fontSize: "20px",
  fontWeight: "400",
  lineHeight: "1",
  color: "#ffffff",
  textTransform: "capitalize",
  background: "#F28021",
  borderColor: "#F28021",
  borderRadius: "10px",
  padding: "15px 20px",
  boxShadow: "none !important",
}));
const CustomLink = styled(Link)(() => ({
  fontSize: "16px",
  fontWeight: "400",
  lineHeight: "1",
  color: "#2C2C2E",
  textDecoration: "none",
  "&:hover": {
    color: "#1085AB",
  textDecoration: "underline",
  }
}));